import formsBackendClient, { ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';
import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/ai-agents']['POST'];
type Input = ThisApi['params'] & ThisApi['body'];

const createAiAgent = async ({ creatorId, questionnaireTemplateId, ...body }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/ai-agents', { creatorId, questionnaireTemplateId });
  const data = await formsBackendClient.post(path, body);
  return data.data;
};

export default createAiAgent;
